import React, { useEffect, useState } from "react";
import { Table, Select, Empty, Layout, Popover, Tag } from "antd";
import apiNotificaciones from "../../api/Notificaciones/api-notificaciones";
import moment from "moment";
import getStorageUser from "../../middlewares/GetStorageUser";

const { Option } = Select;
const { Content } = Layout;
const TablaNotificaciones = () => {
  // const { idParticipante } = useSelector((state: RootState) => state.participantes);

  const [notificaciones, ] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      actualizarNotificacionesVistas
    }
    return () => {
      mounted = false;
    };
  }, []);

  const actualizarNotificacionesVistas = async () => {
    const user = getStorageUser()
    await apiNotificaciones.notificacionesVistas(user.documento);
  }

  const columns: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 10,
      key: "id_postulacion",
      // fixed: context.device === "md"? "left": false,
      className: "border_sh",
      render: (datos: any, record: any, index: number) => (
        <div>{index + 1}</div>
      ),
    },
    {
      title: <span className="as_tbl_hd">Fecha</span>,
      width: 20,
      key: "fecha",
      // fixed: context.device === "md"? "left": false,
      className: "border_sh",
      render: (datos: any, record: any, index: number) => (
        moment(datos.fecha_creacion).add(1, 'd').format('DD-MM-YYYY')
      ),
    },
    {
      title: <span className="as_tbl_hd">Notificación</span>,
      dataIndex: "descripcion",
      key: "descripcion",
      // fixed: context.device === "md"? "left": false,
      width: 100,
      render: (datos) => {
        return (
          datos &&
          (datos.length > 27 ? (
            <Popover content={datos} title="Mensaje">
              <span
                style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
              >{`${datos.substring(0, 80)}...`}</span>
            </Popover>
          ) : (
            datos
          ))
        );
      }
    },
    {
      title: <span className="as_tbl_hd">&#128276;</span>,
      key: "estado",
      dataIndex: "estado",
      // fixed: context.device === "md"? "left": false,
      width: 100,
      render: (datos: any) => {
        return (
          datos &&
            <Tag color={'geekblue'}>
              Nueva
            </Tag>
        );
      }
    },
  ];

  return (
  
    <div className="background-color-F7FBFF h-100">
      {/*
   <div className="col-12 font-size-14px font-family-Montserrat-SemiBold">
      <div className="row">
         <div className="justify-content-center">
            <div className="container-titles-information-component">
               <div className="container-title-left-landing font-family-Montserrat-Regular font-size-24px font-color-FF8900">
                  <span className="font-family-Montserrat-Bold"> Centro de notificaciones</span>
               </div>
            </div>
         </div>
      </div>
   </div>*/}
      <Layout className="container-fluid">
        <Content>
          <div className="row">
            <div className="col-12 col-md-6 pb-2 font-size-14px font-family-Montserrat-Regular">
              Lista de notificaciones
            </div>
            <div className="col-12 col-md-6 pb-2">
              <div className="row g-2">
                <div className="col-10 d-flex justify-content-end align-content-center">
                  <span className="d-flex flex-nowrap pt-2 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                    Registros por página
                  </span>
                </div>
                <div className="col-2 d-flex justify-content-end">
                  <Select
                    defaultValue="10"
                    className="select_table_cont"
                    style={{
                      height: 35,
                      width: 65,
                      fontSize: 12,
                      marginBottom: 10,
                    }}
                  >
                    <Option value="10">10</Option>
                    <Option value="20">20</Option>
                    <Option value="30">30</Option>
                    <Option value="40">40</Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <div className="">
              <Table
                dataSource={notificaciones}
                columns={columns}
                style={{ borderTop: "1px solid #C4C4C4" }}
                locale={{
                  emptyText: (
                    <Empty
                      description="No se han diligenciados datos para está sección"
                      style={{ padding: "50px" }}
                    />
                  ),
                }}
                scroll={{ x: "calc(590px + 50%)", y: 340 }}
                size="small"
                bordered={false}
              />
            </div>
          </div>
        </Content>
      </Layout>
    </div>

  );
};
export default TablaNotificaciones;
